module.exports = __webpack_public_path__ + "img/sellerProduct.fab51bd9.png";